import { useCallback } from 'react'
import { useHistory } from '@fs/zion-router'

/**
 * useSetGridParamInURL - Use this hook when you need to change the grid parameter in the url.
 *    We use the useHistory hook instead of the useQueryParams hook because useHistory is used to update
 *    the image ark in the url and when the ark is updated right before the grid param needs to update,
 *    removeQuery will update the url with the previous ark. We want to keep the new ark.
 */
export default function useSetGridParamInURL() {
  const history = useHistory()
  /**
   * Handle updating the url, this is important because we rely on this parameter in other places in the code (ie InfoSheetWrapper)
   * Of course also important for getting the correct url for feedback
   * @param {Boolean} isOn whether or not grid has been turned on in the ComboViewer
   */
  const setGridParamInURL = useCallback(
    (isOn) => {
      if (isOn) {
        history.replace({
          pathname: window.location.pathname,
          search: `${window.location.search}&grid=on`,
        })
      } else {
        history.replace({
          pathname: window.location.pathname,
          search: window.location.search.replace('&grid=on', ''),
        })
      }
    },
    [history]
  )

  return setGridParamInURL
}
